// removed by extract-text-webpack-plugin
module.exports = {"container":"Layout-container","mainContainer":"Layout-mainContainer","scrollContainer":"Layout-scrollContainer","contentContainer":"Layout-contentContainer"};